import Vue from 'vue';
import Router from 'vue-router';
import { storage } from 'BASE/common/util/util.storage';

const CenterTopMenu = () => import('SKYXH/views/CenterTopMenu.vue');
const Login = () => import('SKYXH/views/Login/Login.vue');
const ChatAnonymity = () => import('SKYXH/views/ChatAnonymity/ChatAnonymity.vue');
const Timeout = () => import('SKYXH/views/ErrorHandle/Timeout.vue');
const Offline = () => import('SKYXH/views/ErrorHandle/Offline.vue');
const Home = () => import('SKYXH/views/Home/Home.vue');
const ErrorMsg = () => import('SKYXH/views/ErrorHandle/ErrorMsg.vue');
const IPRestricted = () => import('SKYXH/views/ErrorHandle/IPRestricted.vue');
const LinkFailure = () => import('SKYXH/views/Register/Register.LinkFailure.vue');
const Bet = () => import('SKYXH/views/Bet/Bet.vue');
const MultiBet = () => import('SKYXH/views/MultiBet/MultiBet.vue');

const AccountInfo = () => import('SKYXH/views/AccountCenter/AccountInfo.vue');
const AwardDetail = () => import('SKYXH/views/AwardDetail/AwardDetail.vue');
const MyDailyPayAndContract = () => import('SKYXH/views/MyDailyPayAndContract/MyDailyPayAndContract.vue');
const AccountSecurity = () => import('SKYXH/views/AccountCenter/AccountSecurity.vue');
const LoginRecord = () => import('SKYXH/views/LoginRecord/LoginRecord.vue');
const DepositRequestCreate = () => import('SKYXH/views/DepositRequest/Create.vue');
const DepositQrcode = () => import('SKYXH/views/DepositRequest/DepositQrcode.vue');
const DepositPayInfo = () => import('SKYXH/views/DepositRequest/PayInfo.vue');
const DownloadHuangingupApplication = () => import('SKYXH/views/Download/HangingUpApplication.vue');
const AppDownload = () => import('SKYXH/views/Download/AppDownload.vue');
const CreatePlayer = () => import('SKYXH/views/Player/Player.Create.vue');
const Player = () => import('SKYXH/views/Player/Player.vue');
const BonusManagement = () => import('SKYXH/views/BonusManagement/BonusManagement.vue');
const HelperCenter = () => import('SKYXH/views/HelperCenter/HelperCenter.vue');
const WithdrawRequest = () => import('SKYXH/views/WithdrawRequest/WithdrawRequest.vue');
const RegisterLink = () => import('SKYXH/views/RegisterLink/RegisterLink.vue');
const BankCard = () => import('SKYXH/views/BankCard/BankCard.vue');
const CreateBankCard = () => import('SKYXH/views/BankCard/BankCard.Create.vue');
const CreateAliPay = () => import('SKYXH/views/BankCard/AliPay.Create.vue');
const CreateWeChat = () => import('SKYXH/views/BankCard/WeChat.Create.vue');
const CreateENCY = () => import('SKYXH/views/BankCard/ENCY.Create.vue');
const Register = () => import('SKYXH/views/Register/Register.vue');
const DepositAndWithdrawRecord = () => import('SKYXH/views/DepositAndWithdrawRecord/DepositAndWithdrawRecord.vue');
const ExternalGameTransRecord = () => import('SKYXH/views/ExternalGameTransRecord/ExternalGameTransRecord.vue');
const ExternalGameSubItem = () => import('SKYXH/views/ExternalGame/ExternalGameSubItem.vue');
const ExternalGameLobby = () => import('SKYXH/views/ExternalGame/ExternalGameLobby.vue');
const TrendChartStatistics = () => import('SKYXH/views/TrendChart/Statistics.vue');
const TrendChartOverview = () => import('SKYXH/views/TrendChart/Overview.vue');
const TransferPointRecord = () => import('SKYXH/views/TransferPointRecord/TransferPointRecord.vue');
const Transfer = () => import('SKYXH/views/TransferPoint/Transfer.vue');
const UserStatisticsReport = () => import('SKYXH/views/UserStatisticsReport/UserStatisticsReport.vue');
const BetRecord = () => import('SKYXH/views/BetRecord/BetRecord.Main.vue');
const DividendRecord = () => import('SKYXH/views/DividendRecord/DividendRecord.vue');
const ProportionalDividend = () => import('SKYXH/views/ProportionalDividend/ProportionalDividend.vue');
const ProfitReport = () => import('SKYXH/views/ProfitReport/ProfitReport.Main.vue');
const ScheduleRecord = () => import('SKYXH/views/ScheduleRecord/ScheduleRecord.Main.vue');
const CashFlowRecord = () => import('SKYXH/views/CashFlowRecord/CashFlowRecord.Main.vue');
const LotteryGameStatistics = () => import('SKYXH/views/LotteryGameStatistics/LotteryGameStatistics.Main.vue');
const DrawHistory = () => import('SKYXH/views/DrawHistory/DrawHistory.vue');
const CreateUSDTAddress = () => import('SKYXH/views/USDTAddress/USDTAddress.Create.vue');
const LegendDownload = () => import('SKYXH/views/Download/LegendDownload.vue');
const LoginDownload = () => import('SKYXH/views/Download/LoginDownload.vue');
const ElectronicPurseManualCreate = () => import('SKYXH/views/ElectronicPurse/ElectronicPurse.create.manual.vue');
const ElectronicPurseQRCodeCreate = () => import('SKYXH/views/ElectronicPurse/ElectronicPurse.create.qrcode.vue');
const IFrame = () => import('SKYXH/views/IFrame.vue');
const Activity = () => import('SKYXH/views/Activity/Activity.vue');

Vue.use(Router);

Router.prototype.refreshTo = function (path) {
    window.location.href = path;
};

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        { path: '/Login', name: 'Login', component: Login, meta: { ignoreAuth: true } },
        { path: '/ChatAnonymity', name: 'ChatAnonymity', component: ChatAnonymity, meta: { ignoreAuth: true } },
        { path: '/Timeout', name: 'Timeout', component: Timeout, meta: { ignoreAuth: true } },
        { path: '/Offline', name: 'Offline', component: Offline, meta: { ignoreAuth: true } },
        { path: '/LinkFailure', name: 'LinkFailure', component: LinkFailure, meta: { ignoreAuth: true } },
        { path: '/ErrorMsg', name: 'ErrorMsg', component: ErrorMsg, meta: { ignoreAuth: true } },
        { path: '/IPRestricted', name: 'IPRestricted', component: IPRestricted, meta: { ignoreAuth: true } },
        {
            path: '/DepositPayInfo/:SerialNumber',
            name: 'DepositPayInfo',
            component: DepositPayInfo,
            meta: { ignoreAuth: true },
        },
        { path: '/Register/:code', name: 'Register', component: Register, meta: { ignoreAuth: true } },
        //以上是忽略驗證是否有登入，需登入後才顯得ignoreAuth請不要設置

        { path: '/', name: 'Home', component: Home },
        { path: '/Bet/:id', name: 'Bet', component: Bet },
        { path: '/MultiBet/:type', name: 'MultiBet', component: MultiBet },
        { path: '/DepositQrcode', name: 'DepositQrcode', component: DepositQrcode },
        { path: '/HangingUpApplication', component: DownloadHuangingupApplication },
        { path: '/AppDownload', component: AppDownload },
        { path: '/HelperCenter', component: HelperCenter },
        { path: '/ExternalGameSubItem/:gameType', component: ExternalGameSubItem },
        { path: '/ExternalGameLobby/:gameCategory', component: ExternalGameLobby },
        { path: '/LegendDownload', component: LegendDownload },
        { path: '/LoginDownload', component: LoginDownload },
        { path: '/Activity', name: 'Activity', component: Activity },
        {
            path: '/Center',
            component: CenterTopMenu,
            children: [
                { path: 'AccountInfo', component: AccountInfo },
                { path: 'AwardDetail', component: AwardDetail },
                { path: 'MyDailyPayAndContract', component: MyDailyPayAndContract },
                { path: 'BankCard', name: 'BankCard', component: BankCard },
                { path: 'CreateBankCard', name: 'CreateBankCard', component: CreateBankCard },
                { path: '/CreateAliPay/:CurrentBankType', name: 'CreateAliPay', component: CreateAliPay, props: true },
                { path: '/CreateWeChat/:CurrentBankType', name: 'CreateWeChat', component: CreateWeChat, props: true },
                { path: '/CreateECNY/:CurrentBankType', name: 'CreateENCY', component: CreateENCY, props: true },
                { path: 'AccountSecurity', component: AccountSecurity },
                { path: 'LoginRecord', component: LoginRecord },
                { path: 'DepositCreate', component: DepositRequestCreate },
                { path: 'CreatePlayer', component: CreatePlayer, meta: { isAgentAllow: true } },
                { path: 'Player', component: Player, meta: { isAgentAllow: true } },
                { path: 'BonusManagement', component: BonusManagement, meta: { isAgentAllow: true } },
                { path: 'WithdrawRequest', component: WithdrawRequest },
                { path: 'RegisterLink', component: RegisterLink, meta: { isAgentAllow: true } },
                { path: 'ExternalGameTransRecord', component: ExternalGameTransRecord },
                { path: 'DepositAndWithdrawRecord', component: DepositAndWithdrawRecord },
                { path: 'TrendChartStatistics', component: TrendChartStatistics, meta: { isAgentAllow: true } },
                { path: 'TrendChartOverview', component: TrendChartOverview, meta: { isAgentAllow: true } },
                { path: 'TransferPointRecord', component: TransferPointRecord },
                { path: 'UserStatisticsReport', component: UserStatisticsReport, meta: { isAgentAllow: true } },
                { path: 'Transfer', name: 'Transfer', component: Transfer },
                { path: 'BetRecord', name: 'BetRecord', component: BetRecord },
                { path: 'DividendRecord', name: 'DividendRecord', component: DividendRecord },
                { path: 'ProportionalDividend',name:'ProportionalDividend', component: ProportionalDividend},
                { path: 'ProfitReport', component: ProfitReport },
                { path: 'ScheduleRecord', component: ScheduleRecord },
                { path: 'CashFlowRecord', component: CashFlowRecord },
                { path: 'LotteryGameStatistics', component: LotteryGameStatistics },
                { path: 'CreateUSDTAddress/:currencyType', name: 'CreateUSDTAddress', component: CreateUSDTAddress },
                { path: 'CreateElectronicPurseManual', name: 'ElectronicPurseManualCreate', component: ElectronicPurseManualCreate, props: true },
                { path: 'CreateElectronicPurseQRCode', name: 'ElectronicPurseQRCodeCreate', component: ElectronicPurseQRCodeCreate, props: true },
            ],
        },
        { path: '/DrawHistory/:id', name: 'DrawHistory', component: DrawHistory },
        { path: '/IFrame', name: 'IFrame', component: IFrame },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name == 'Login') {
        //透過window.location.href跳回Login遇載app.vue時會是之前的權限需將token先砍掉
        storage.local.remove(storage.keys.ACCESS_TOKEN);
    }

    if (to.matched.some((record) => record.meta.ignoreAuth)) {
        next();
    } else {
        let isAgent = storage.local.get(storage.keys.ISAGENT);
        if (to.matched.some((record) => record.meta.isAgentAllow) && !isAgent) {
            //若登入帳號不是Agent，則回到首頁
            next('/');
        }
        if (storage.local.get(storage.keys.ACCESS_TOKEN)) {
            next();
        } else if (to.name === 'Home' && from.fullPath === to.fullPath) {
            //如平台沒有未登入首頁時須設定該部分，當玩家直接透過網址做網頁跳轉時如沒token需直接跳到登入
            router.refreshTo('/speedtest');
        } else {
            next('/Timeout'); // 認證已過期
        }
    }
});

export default router;
